import enGB from "./en-GB.ts";
export default {
  "Language-en-AU": "English (Australia)",
  ...enGB,
};
